














  import Routes from '@/router/routes';
  import Vue from 'vue';

  export default Vue.extend({
    name: 'NonAutorise',
    methods: {
      onRetournerAccueil(): void {
        this.$router.push({ name: Routes.Accueil });
      },
    },
  });
